/**
 * Default API instances wired to the singleton HttpClient.
 *
 * Slices import from here. Tests `jest.mock('services')` (or pass custom
 * APIs via constructor helpers) to substitute in a mock implementation.
 */

import { createCheckoutApi, type CheckoutApi } from './checkoutApi';
import { createHttpClient, type HttpClient } from './http';
import { createPaymentMethodsApi, type PaymentMethodsApi } from './paymentMethodsApi';

export const httpClient: HttpClient = createHttpClient();
export const checkoutApi: CheckoutApi = createCheckoutApi(httpClient);
export const paymentMethodsApi: PaymentMethodsApi = createPaymentMethodsApi(httpClient);

export type { CheckoutApi, PaymentMethodsApi, HttpClient };
export { BffError, NetworkError } from './http';
